<style lang="scss">
@import '../node_modules/bootstrap/scss/bootstrap-reboot.scss';
@import '~scss/_variables';
@import '~scss/app';
@import '~scss/_iubenda';
@import '~scss/_tooltip';
</style>

<template>
    <div id="app">
        <NavComp></NavComp>
        <Loading v-if="$store.state.isLoading"></Loading>
        <router-view v-if="!$store.state.isLoading"/>
    </div>
</template>

<script>
import Nav from '@/components/Nav';
import Loading from '@/components/Loading';

export default {
    components: { NavComp: Nav, Loading }
};
</script>
